/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Outline_Size_LabelInputs */



/**
* | output |
* | --- |
* | "Outline Size" |
*
* @param {Video_Export_Outline_Size_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_outline_size_label = /** @type {((inputs?: Video_Export_Outline_Size_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Outline_Size_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Taille du contour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Umrissgröße")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dimensioni del contorno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Размер контура")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tamaño del contorno")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("轮廓尺寸")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アウトラインサイズ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रूपरेखा का आकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tamanho do contorno")
	return /** @type {LocalizedString} */ ("Outline Size")
});